import React, { Component } from 'react';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';
import BlockUi from 'react-block-ui';
import { firebase } from '../../../firebase';
import {
  getBraintreeClientToken,
  cancelSubscription,
  editSubscription
} from '../../../redux/actions/user-actions';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import swal from 'sweetalert2';
import 'react-block-ui/style.css';
import logo from '../../../images/inflo_logo.png';

require('sweetalert2/dist/sweetalert2.css');

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class PaypalPremiumPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropinInstance: null,
      error: null,
      loading: false,
      name: null,
      surname: null,
      phone: null
    };
  }

  componentDidMount() {
    if (
      firebase.auth.currentUser !==
      null /*&& firebase.auth.currentUser.emailVerified*/
    ) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(getBraintreeClientToken(token));
      });
    }
  }

  componentWillUnmount() {
    if (this.state.dropinInstance) {
      this.state.dropinInstance.teardown(function(err) {
        if (err) {
          console.error('An error occurred during teardown:', err);
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.braintreeToken &&
      nextProps.braintreeToken !== this.props.braintreeToken
    ) {
      let $this = this;

      dropin.create(
        {
          authorization: nextProps.braintreeToken,
          container: '.dropin-container',
          paypal: {
            flow: 'vault'
          }
        },
        function(createErr, dropinInstance) {
          $this.setState({ dropinInstance });
        }
      );
    }
    this.setState({
      name: nextProps.name,
      surname: nextProps.surname,
      phone: nextProps.phone
    });
  }

  editSubscription = () => {
    const { name, surname, phone } = this.state;

    const { dispatch } = this.props;

    const $this = this;

    this.state.dropinInstance.requestPaymentMethod(
      (requestPaymentMethodErr, payload) => {
        if (requestPaymentMethodErr) {
          this.setState({ error: requestPaymentMethodErr.message });
        } else {
          this.setState({ error: null, loading: true });
          firebase.auth.currentUser.getIdToken().then((token) => {
            dispatch(
              editSubscription(
                token,
                payload.nonce,
                name,
                surname,
                phone,
                () => {
                  swal({
                    imageUrl: logo,
                    title:
                      '<div class="titleModal">Subscription has been updated.</div>',
                    html: '<p class="contentModal"></p>',
                    showConfirmButton: false,
                    showCloseButton: true,
                    background: '#121C24',
                    allowOutsideClick: false
                  });
                  $this.setState({ error: null, loading: false });
                },
                () => {
                  swal({
                    imageUrl: logo,
                    title:
                      '<div class="titleModal">There was an error updating the subscription.</div>',
                    html: '<p class="contentModal"></p>',
                    showConfirmButton: false,
                    showCloseButton: true,
                    background: '#121C24',
                    allowOutsideClick: false
                  });
                  $this.setState({
                    error: 'Error updating subscription',
                    loading: false
                  });
                }
              )
            );
          });
        }
      }
    );
  };

  cancelSubscription = () => {
    const { dispatch } = this.props;

    const $this = this;

    swal({
      imageUrl: logo,
      title: '<div class="titleModal">Cancel your subscription</div>',
      html: '<p class="contentModal">Are you sure you want to continue?</p>',
      showCancelButton: true,
      showCloseButton: true,
      background: '#121C24',
      allowOutsideClick: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#E31690'
    })
      .then((result) => {
        if (result) {
          $this.setState({ error: null, loading: true });
          firebase.auth.currentUser.getIdToken().then((token) => {
            dispatch(
              cancelSubscription(
                token,
                () => {
                  swal({
                    imageUrl: logo,
                    title:
                      '<div class="titleModal">Your subscription has been cancelled.</div>',
                    html: '<p class="contentModal"></p>',
                    showConfirmButton: false,
                    showCloseButton: true,
                    background: '#121C24',
                    allowOutsideClick: false
                  });
                  $this.setState({ error: null, loading: false });
                },
                () => {
                  swal({
                    imageUrl: logo,
                    title:
                      '<div class="titleModal">There was an error cancelling the subscription.</div>',
                    html: '<p class="contentModal"></p>',
                    showConfirmButton: false,
                    showCloseButton: true,
                    background: '#121C24',
                    allowOutsideClick: false
                  });
                  $this.setState({
                    error: 'Error cancelling subscription',
                    loading: false
                  });
                }
              )
            );
          });
        }
      })
      .catch(() => {});
  };

  render() {
    const { name, surname, phone } = this.state;

    const { email } = this.props;

    const isInvalid =
      name === '' ||
      name === undefined ||
      surname === '' ||
      surname === undefined ||
      phone === '' ||
      phone === undefined ||
      email === '' ||
      email === undefined;

    return (
      <BlockUi tag="div" blocking={this.state.loading}>
        <div className="main-page" style={{ marginTop: 15, padding: 10 }}>
          <Dialog
            ref={(el) => {
              this.dialog = el;
            }}
          />
          <form>
            <FormGroup controlId="name">
              <FormControl
                componentClass="input"
                className="styleFieldForm"
                placeholder="Name"
                type="text"
                defaultValue={this.props.name}
                onChange={(event) =>
                  this.setState(byPropKey('name', event.target.value))
                }
              />
            </FormGroup>
            <FormGroup controlId="surname">
              <FormControl
                componentClass="input"
                className="styleFieldForm"
                placeholder="Surname"
                type="text"
                defaultValue={this.props.surname}
                onChange={(event) =>
                  this.setState(byPropKey('surname', event.target.value))
                }
              />
            </FormGroup>
            <FormGroup controlId="email">
              <FormControl
                componentClass="input"
                className="styleFieldForm"
                placeholder="Email"
                type="email"
                defaultValue={this.props.email}
                onChange={(event) =>
                  this.setState(byPropKey('email', event.target.value))
                }
              />
            </FormGroup>
            <FormGroup controlId="phone">
              <FormControl
                componentClass="input"
                className="styleFieldForm"
                placeholder="Phone"
                type="text"
                defaultValue={this.props.phone}
                onChange={(event) =>
                  this.setState(byPropKey('phone', event.target.value))
                }
              />
            </FormGroup>

            <div className="dropin-container"></div>
            {this.state.dropinInstance ? (
              <div style={{ textAlign: 'center', marginTop: '15px' }}>
                <Button
                  type="button"
                  disabled={isInvalid}
                  className="btn-general btn-paypal"
                  onClick={this.editSubscription.bind(this)}
                >
                  Update Payment Method
                </Button>
                <Button
                  type="button"
                  className="btn-general btn-paypal"
                  onClick={this.cancelSubscription.bind(this)}
                  style={{ backgroundColor: '#CBCBCC', border: 'none' }}
                >
                  Cancel Subscription
                </Button>
              </div>
            ) : (
              ''
            )}
            <div style={{ color: 'red' }}>{this.state.error}</div>
          </form>
        </div>
      </BlockUi>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    braintreeToken: store.user.braintreeToken
  };
};

export default connect(mapStateToProps)(PaypalPremiumPage);
